import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { RegisterPasswordComponent } from './register-password/register-password.component';
import { RegisterComponent } from './register/register.component';
import { UserProfileComponent } from './user-profile/user-profile.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { NgModule } from '@angular/core';
import { SuccessComponent } from './success/success.component';
import { ApplicationDetailsComponent } from './application-details/application-details.component';
import { AuthGuard } from './shared/auth.guard';
import { ConfirmPaymentComponent } from './confirm-payment/confirm-payment.component';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { ApplicationsListComponent } from './applications-list/applications-list.component';
import { SuccessPaymentComponent } from './success-payment/success-payment.component';
import { PaymentsComponent } from './payments/payments.component';
import { LicenceApplicationComponent } from './licence-application/licence-application.component';
import { FailedPaymentComponent } from './failed-payment/failed-payment.component';
import { FinesComponent } from './fines/fines.component';
import { ConfirmPaymentFinesComponent } from './fines/confirm-payment-fines/confirm-payment-fines.component';

export const routes: Routes = [

    { path: '', pathMatch: 'full', redirectTo: 'app-list' },
    { path: 'login', component: LoginComponent, canActivate: [AuthGuard] },
    { path: 'forgot-password', component: ForgotPasswordComponent, canActivate: [AuthGuard] },
    { path: 'licence-application', component: LicenceApplicationComponent, canActivate: [AuthGuard] },
    { path: 'register-password', component: RegisterPasswordComponent, canActivate: [AuthGuard] },
    { path: 'register', component: RegisterComponent, canActivate: [AuthGuard] },
    { path: 'user-profile', component: UserProfileComponent, canActivate: [AuthGuard] },
    { path: 'dashboard', component: DashboardComponent, canActivate: [AuthGuard] },//Not in use
    { path: 'app-list', component: ApplicationsListComponent, canActivate: [AuthGuard] },
    { path: 'success', component: SuccessComponent },
    { path: 'application-details', component: ApplicationDetailsComponent, canActivate: [AuthGuard] },
    { path: 'confirm-payment', component: ConfirmPaymentComponent, canActivate: [AuthGuard] },
    { path: 'change-password', component: ChangePasswordComponent, canActivate: [AuthGuard] },
    { path: 'reset-password', component: ResetPasswordComponent, canActivate: [AuthGuard] },
    { path: 'payment-success', component: SuccessPaymentComponent },
    { path: 'payment-failed', component: FailedPaymentComponent },
    { path: 'payments', component: PaymentsComponent, canActivate: [AuthGuard] },
    { path: 'fines', component: FinesComponent, canActivate: [AuthGuard] },
    { path: 'confirm-payment-fines', component: ConfirmPaymentFinesComponent, canActivate: [AuthGuard] }
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class AppRoutingModule { }
